"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9403],{

/***/ 92929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K$": function() { return /* binding */ deleteJSON; },
/* harmony export */   "ZV": function() { return /* binding */ fetchJSON; },
/* harmony export */   "ty": function() { return /* binding */ postJSON; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70528);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68641);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60818);



function fetchJSON(path) {
    return _fetchJSON.apply(this, arguments);
}
function _fetchJSON() {
    _fetchJSON = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path) {
        var ref, _throwOnError, throwOnError, _tmp, response, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError;
                    _tmp1 = {};
                    return [
                        4,
                        __webpack_require__.g.fetch(path, (_tmp1.headers = new Headers({
                            Accept: "application/json"
                        }), _tmp1.credentials = "same-origin", _tmp1))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return _fetchJSON.apply(this, arguments);
}
function postJSON(path, body) {
    return _postJSON.apply(this, arguments);
}
function _postJSON() {
    _postJSON = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path, body) {
        var ref, _throwOnError, throwOnError, _headers, headers, _credentials, credentials, _tmp, _tmp1, response, _tmp2;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    _tmp1 = {};
                    ref = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : _tmp, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError, _headers = ref.headers, headers = _headers === void 0 ? _tmp1 : _headers, _credentials = ref.credentials, credentials = _credentials === void 0 ? "same-origin" : _credentials;
                    _tmp2 = {};
                    return [
                        4,
                        __webpack_require__.g.fetch(path, (_tmp2.method = "POST", _tmp2.body = JSON.stringify(body), _tmp2.headers = new Headers((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        }, headers)), _tmp2.credentials = credentials, _tmp2))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return _postJSON.apply(this, arguments);
}
function deleteJSON(path) {
    return _deleteJSON.apply(this, arguments);
}
function _deleteJSON() {
    _deleteJSON = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path) {
        var ref, _throwOnError, throwOnError, _tmp, response, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError;
                    _tmp1 = {};
                    return [
                        4,
                        __webpack_require__.g.fetch(path, (_tmp1.method = "DELETE", _tmp1.headers = new Headers({
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        }), _tmp1.credentials = "same-origin", _tmp1))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return _deleteJSON.apply(this, arguments);
}
function unwrapJSONResponse(response, throwOnError) {
    return _unwrapJSONResponse.apply(this, arguments);
}
function _unwrapJSONResponse() {
    _unwrapJSONResponse = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(response, throwOnError) {
        var errorMessage, originalMessage, errData, ref, ref1, ref2, ref3, res, message, data, err, _$err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (response.ok || !throwOnError) {
                        return [
                            2,
                            response.json()
                        ];
                    }
                    errorMessage = "HTTP Status Error: ".concat(response.status);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    res = _state.sent();
                    message = ((ref = res.error) === null || ref === void 0 ? void 0 : ref.message) || ((ref1 = res.meta) === null || ref1 === void 0 ? void 0 : ref1.error);
                    if (message) {
                        errorMessage = "HTTP Status Error: ".concat(response.status, " - ").concat(message);
                        originalMessage = message;
                    }
                    data = ((ref2 = res.error) === null || ref2 === void 0 ? void 0 : ref2.data) || ((ref3 = res.meta) === null || ref3 === void 0 ? void 0 : ref3.errorData);
                    if (data) {
                        errData = data;
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    // biome-ignore lint/suspicious/noConsole: log
                    console.error(err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    _$err = new Error(errorMessage);
                    // Mark this error as having the response data to work with
                    // As opposed to a network error
                    (_$err).responseSucceeded = true;
                    _$err.statusCode = response.status;
                    _$err.originalMessage = originalMessage;
                    _$err.data = errData;
                    throw _$err;
            }
        });
    });
    return _unwrapJSONResponse.apply(this, arguments);
}


/***/ }),

/***/ 56393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oi": function() { return /* reexport */ checkParam; },
  "js": function() { return /* binding */ mapObj; }
});

// UNUSED EXPORTS: Enum, anyValueDefined, coalesceBlankPropsToNull, filterNilValues, filterObj, listOfKeys, listOfValues, placeKeyInData

// EXTERNAL MODULE: ../../../../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(78149);
// EXTERNAL MODULE: ../../../../../node_modules/ramda/es/index.js + 230 modules
var es = __webpack_require__(34080);
;// CONCATENATED MODULE: ../../../../libraries/src/language-helpers/objects/check-object-keys.ts
/* eslint array-callback-return: "off" */ 
function checkParam(obj) {
    Object.entries(obj).map(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        if (typeof value === "object" && value !== null) {
            checkParam(value);
        }
        if (value === undefined || value === null) {
            throw new Error("".concat(key, " is a mandatory parameter"));
        }
    });
}

;// CONCATENATED MODULE: ../../../../libraries/src/language-helpers/objects/index.ts





function filterObj(fn, obj) {
    var res = {};
    Object.entries(obj).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
        if (fn(k, v)) {
            res[k] = v;
        }
    });
    return res;
}
function mapObj(fn, obj) {
    var res = {};
    Object.entries(obj).forEach(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
        var ref = (0,src_sliced_to_array/* default */.Z)(fn(k, v), 2), newK = ref[0], newV = ref[1];
        res[newK] = newV;
    });
    return res;
}
function filterNilValues(obj) {
    var result = filterObj(function(_k, v) {
        return !isNil(v);
    }, obj);
    return result;
}
function coalesceBlankPropsToNull(obj) {
    return mapObj(function(k, v) {
        return [
            k,
            v || null
        ];
    }, obj);
}
function placeKeyInData(keyName, obj) {
    if (!keyName || typeof keyName !== "string") {
        throw new Error("keyName must be provided to placeKeyInData(keyName, obj)");
    }
    return mapObj(function(key, value) {
        return [
            key,
            _object_spread_props(_object_spread({}, value), _define_property({}, keyName, key)), 
        ];
    }, obj);
}
function listOfKeys(obj) {
    return Object.entries(obj).filter(function(param) {
        var _param = _sliced_to_array(param, 2), v = _param[1];
        return v;
    }).map(function(param) {
        var _param = _sliced_to_array(param, 1), k = _param[0];
        return k;
    });
}
function listOfValues(obj) {
    return Object.entries(obj).filter(function(param) {
        var _param = _sliced_to_array(param, 2), v = _param[1];
        return v;
    }).map(function(param) {
        var _param = _sliced_to_array(param, 2), v = _param[1];
        return v;
    });
}





/***/ }),

/***/ 11523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ isDomainValid; },
/* harmony export */   "J2": function() { return /* binding */ appendResourceType; },
/* harmony export */   "Ri": function() { return /* binding */ createURL; },
/* harmony export */   "ru": function() { return /* binding */ appendQuery; }
/* harmony export */ });
/* unused harmony export buildPath */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78149);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25439);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34080);
/* harmony import */ var _language_helpers_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56393);
// biome-ignore lint/style/useNodejsImportProtocol: need webpack to resolve this import
// biome-ignore lint/style/useNodejsImportProtocol: need webpack to resolve this import




function createURL(param) {
    var host = param.host, path = param.path, queryParams = param.queryParams, hash = param.hash;
    var url = new URL("".concat(host).concat(path));
    Object.entries(queryParams).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (value === undefined || value === null) {
            return;
        }
        if (typeof value === "object") {
            url.searchParams.set(key, JSON.stringify(value));
        } else {
            url.searchParams.set(key, value);
        }
    });
    if (hash) {
        url.hash = hash;
    }
    return url.toString();
}
function appendQuery(path, query) {
    if ((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .isNil */ .kKJ)(query)) {
        return path;
    }
    var url = new URL(path, "https://example.com");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(query)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_step.value, 2), name = _value[0], value = _value[1];
            if (!(0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .isNil */ .kKJ)(value)) {
                url.searchParams.append(name, value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return url.pathname + url.search;
}
function appendResourceType(type, url) {
    (0,_language_helpers_objects__WEBPACK_IMPORTED_MODULE_2__/* .checkParam */ .oi)({
        type: type
    });
    (0,_language_helpers_objects__WEBPACK_IMPORTED_MODULE_2__/* .checkParam */ .oi)({
        url: url
    });
    var parsed = (0,url__WEBPACK_IMPORTED_MODULE_0__.parse)(url);
    var path = buildPath(type, parsed);
    if (!parsed.hostname) {
        return path;
    }
    return "".concat(parsed.protocol, "//").concat(parsed.host).concat(path);
}
function buildPath(type, param) {
    var pathname = param.pathname, search = param.search;
    if (search) {
        return "".concat(pathname, ".").concat(type).concat(search);
    }
    return "".concat(pathname, ".").concat(type);
}
var DOMAIN_REGEX = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/;
function isDomainValid(domain) {
    return !!(domain === null || domain === void 0 ? void 0 : domain.match(DOMAIN_REGEX));
}


/***/ }),

/***/ 39144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FullStorySnippetString; },
/* harmony export */   "S": function() { return /* binding */ FullStorySnippet; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60586);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90171);
/* harmony import */ var react_inline_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9049);
/* harmony import */ var react_inline_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_inline_script__WEBPACK_IMPORTED_MODULE_2__);



var FullStorySnippetString = '\n  window[\'_fs_host\'] = \'fullstory.com\';\n  window[\'_fs_script\'] = \'edge.fullstory.com/s/fs.js\';\n  window[\'_fs_org\'] = \'RNRSF\';\n  window[\'_fs_namespace\'] = \'FS\';\n  !function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\n  return!(h in m)||(m.console&&m.console.log&&m.console.log(\'FullStory namespace conflict. Please set window["_fs_namespace"].\'),!1)}(e)\n  ;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\n  d&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{\n  then:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){\n  h(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,""),"function"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}\n  ;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){\n  "function"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){\n  (o=n.createElement(t)).async=!0,o.crossOrigin="anonymous",o.src="https://"+l,o.onerror=function(){y("Error loading "+l)}\n  ;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}\n  function h(b,h,d){g(b,h,d,1)}function d(b,d,j){h("setProperties",{type:b,properties:d},j)}function j(b,h){d("user",b,h)}function r(b,h,d){j({\n  uid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h("trackEvent",{\n  name:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h("shutdown")},g.restart=function(){h("restart")},\n  g.log=function(b,d){h("log",{level:b,msg:d})},g.consent=function(b){h("setIdentity",{consent:!arguments.length||b})}}(),s="fetch",\n  f="XMLHttpRequest",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v="2.0.0")\n  }(window,document,window._fs_namespace,"script",window._fs_script);\n';
function FullStorySnippet() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_inline_script__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: FullStorySnippetString
    });
}


/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ routeTo; },
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70528);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68641);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14432);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7464);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60818);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60586);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68964);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11141);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90171);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62546);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: inherit;\n  :hover {\n    color: inherit;\n  }\n\n  text-decoration: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(_param) {
    var href = _param.href, path = _param.path, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "href",
        "path",
        "children"
    ]);
    if (typeof href === "string" && !href.startsWith("/")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            href: href
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        as: path,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            children: children
        }))
    });
})(_templateObject(), function(param) {
    var underline = param.underline;
    return underline ? "underline" : "none";
});
function routeTo(href, path) {
    return _routeTo.apply(this, arguments);
}
function _routeTo() {
    _routeTo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(href, path) {
        var scroll;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    scroll = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                    return [
                        4,
                        next_router__WEBPACK_IMPORTED_MODULE_3___default().push(href, path)
                    ];
                case 1:
                    _state.sent();
                    if (scroll) {
                        scrollToTop();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _routeTo.apply(this, arguments);
}
function scrollToTop() {
    if (__webpack_require__.g.window) {
        __webpack_require__.g.window.scrollTo(0, 0);
    }
}


/***/ }),

/***/ 15334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70528);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60818);
/* harmony import */ var _purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92929);
/* harmony import */ var _purple_dot_libraries_src_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11523);
/* harmony import */ var _components_common_linking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95922);





function expressPage(pageComponent) {
    if (componentHasProps(pageComponent)) {
        pageComponent.getInitialProps = getInitialProps;
    }
    return pageComponent;
}
function componentHasProps(pageComponent) {
    return pageComponent.length > 0;
}
// eslint-disable-next-line func-style
var getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var req, query, asPath, url, data, __redirect, pathname, q, path, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    req = param.req, query = param.query, asPath = param.asPath;
                    if (!!isOnServer(req)) return [
                        3,
                        2
                    ];
                    url = (0,_purple_dot_libraries_src_url__WEBPACK_IMPORTED_MODULE_0__/* .appendResourceType */ .J2)("json", asPath);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_4__/* .fetchJSON */ .ZV)(url)
                    ];
                case 1:
                    data = _state.sent();
                    _tmp = {};
                    _tmp1 = {};
                    if (data._redirect) {
                        __redirect = data._redirect, pathname = __redirect.pathname, q = __redirect.query, path = __redirect.path;
                        void (0,_components_common_linking__WEBPACK_IMPORTED_MODULE_1__/* .routeTo */ .E)((_tmp.pathname = pathname, _tmp.query = q, _tmp), path);
                        return [
                            2,
                            _tmp1
                        ];
                    }
                    return [
                        2,
                        data
                    ];
                case 2:
                    return [
                        2,
                        query
                    ];
            }
        });
    });
    return function getInitialProps(_) {
        return _ref.apply(this, arguments);
    };
}();
function isOnServer(req) {
    return !!req;
}
/* harmony default export */ __webpack_exports__["Z"] = (expressPage);


/***/ })

}]);